import Footer from "./Footer";
import Header from "./Header";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />

      <section className="bg-white py-5">
        <div className="container">
          <h1 className="display-6 text-dark">Privacy Policy</h1>

          <section>
            <h3 className="text-dark">1. Introduction</h3>
            <p>
              Welcome to <u>Visualaey</u>. Your privacy is important to us. This
              Privacy Policy explains how we collect, use, and protect your
              personal information when you use our platform.
            </p>
          </section>

          <section>
            <h3 className="text-dark">2. Information We Collect</h3>
            <p>We may collect the following types of information:</p>
            <ul>
              <li>Personal details such as name, email, phone number.</li>
              <li>Photos uploaded to our platform.</li>
              <li>Facial recognition data for matching purposes.</li>
              <li>
                Usage data such as IP address, device type, and browsing
                activity.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">3. How We Use Your Information</h3>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and improve our services.</li>
              <li>
                Match guests with photos using AI-powered facial recognition.
              </li>
              <li>Send notifications, updates, or promotional messages.</li>
              <li>Prevent fraud, abuse, and maintain platform security.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">4. Sharing Your Information</h3>
            <p>
              We do not sell your personal information. We may share your
              information with:
            </p>
            <ul>
              <li>
                Service providers who assist in delivering our services (e.g.,
                cloud storage, payment processing).
              </li>
              <li>Law enforcement or legal authorities if required by law.</li>
              <li>
                Event organizers to manage event-specific photo galleries.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">5. Data Security</h3>
            <p>
              Visualaey uses advanced security measures, including encryption
              and secure cloud storage, to protect your personal and photo data.
              While we strive to protect your information, no method of
              transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h3 className="text-dark">6. Cookies and Tracking</h3>
            <p>
              We may use cookies and similar tracking technologies to enhance
              your experience, analyze usage patterns, and improve our services.
              You can manage your cookie preferences through your browser
              settings.
            </p>
          </section>

          <section>
            <h3 className="text-dark">7. Third-Party Services</h3>
            <p>
              Some features of Visualaey integrate with third-party services,
              such as Razorpay for payments. These services have their own
              privacy policies, and Visualaey is not responsible for their
              practices.
            </p>
          </section>

          <section>
            <h3 className="text-dark">8. User Rights</h3>
            <p>You have the right to:</p>
            <ul>
              <li>Access and download your personal data.</li>
              <li>Request correction or deletion of your data.</li>
              <li>Opt-out of marketing communications.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">9. Retention of Data</h3>
            <p>
              We retain your personal and photo data only for as long as
              necessary to provide our services or comply with legal
              obligations.
            </p>
          </section>

          <section>
            <h3 className="text-dark">10. Changes to This Policy</h3>
            <p>
              Visualaey may update this Privacy Policy from time to time. Users
              will be notified of significant changes via email or platform
              notifications. Continued use of our platform constitutes
              acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h3 className="text-dark">11. Contact Us</h3>
            <p>
              For any questions or concerns about this Privacy Policy, please
              contact us at{" "}
              <a href="mailto:support@visualaey.com">support@visualaey.com</a>.
            </p>
          </section>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
